import { Component, OnInit, HostBinding, OnDestroy } from '@angular/core';
import{Router, NavigationEnd} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppSettings } from '../app-settings';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare let gtag: Function;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  @HostBinding('attr.inert')
  get isInert(): boolean | null {
    return this.dialogsOpen ? true : null;
  }

  private dialogsOpen = false;
  private destroy$ = new Subject<void>();

	constructor(
		public router: Router,
		private appSettings: AppSettings,
    private matDialog: MatDialog
  ) {   
		this.router.events.subscribe(event => {
			if(event instanceof NavigationEnd){
				gtag('config', this.appSettings.googleAnalyticsId, 
					{
						'page_path': event.urlAfterRedirects
					}
				);
			}
		});

    // Subscribe to dialog state changes
    this.matDialog.afterOpened.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.dialogsOpen = this.matDialog.openDialogs.length > 0;
    });

    this.matDialog.afterAllClosed.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.dialogsOpen = false;
    });
 }

	ngOnInit() {
    // Initial state check
    this.dialogsOpen = this.matDialog.openDialogs.length > 0;
	}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
